import type { ReactNode } from "react"
import { createElement, Fragment } from "react"
import Link from "@onestore/hel/dist/components/quarks/Link"
import { Text } from "@ionos-web-design-system/react"
import type { Components } from "react-markdown"

export const infoBar: Components = {
  strong: ({ children }: { children: ReactNode }) =>
    createElement(Text, { variant: "bodySm", weight: "bold" }, children),
  a: (({ href, children }: { href?: string; children: ReactNode }) =>
    createElement(Link, {
      href,
      openInNewTab: true,
      title: href ?? "",
      children,
    })) as Components["a"],
  p: ({ children }: { children: ReactNode }) =>
    createElement(Fragment, null, children),
} as Components
